import { render } from "./language-select-right-corner.vue?vue&type=template&id=5d227679"
import script from "./language-select-right-corner.vue?vue&type=script&lang=js"
export * from "./language-select-right-corner.vue?vue&type=script&lang=js"

import "./language-select-right-corner.vue?vue&type=style&index=0&id=5d227679&lang=css"
script.render = render

export default script